import * as PropTypes from 'prop-types';
import React, {useState} from "react";

const RangeSelector = ({ value, minVal, maxVal, onChange, buttonStyle, buttonClass, textStyle, textClass, containerClass, containerStyle, onMinBound, onMaxBound }) => {
  function attemptChange(newValue) {
    if (minVal !== null && newValue < minVal) {
      onMinBound();
      return;
    }

    if (maxVal !== null && newValue > maxVal) {
      onMaxBound();
      return;
    }

    onChange(newValue);
  }

  return (
    <div style={containerStyle} className={containerClass}>
      <button onClick={() => attemptChange(value - 1)} className={`px-2 me-2 ${buttonClass}`} style={buttonStyle}>-</button>
      <span className={textClass} style={textStyle}>{value}</span>
      <button onClick={() => attemptChange(value + 1)} className={`px-2 ms-2 ${buttonClass}`} style={buttonStyle}>+</button>
    </div>
  );
};

RangeSelector.propTypes = {
  value: PropTypes.number,
  minVal: PropTypes.number,
  maxVal: PropTypes.number,
  onChange: PropTypes.func,
  buttonStyle: PropTypes.object,
  buttonClass: PropTypes.string,
  textStyle: PropTypes.object,
  textClass: PropTypes.string,
  containerStyle: PropTypes.object,
  containerClass: PropTypes.string,
  onMinBound: PropTypes.func,
  onMaxBound: PropTypes.func
};

RangeSelector.defaultProps = {
  initialVal: 1,
  minVal: null,
  maxVal: null,
  onChange: null,
  buttonStyle: { border: "none", borderRadius: "5px", width: "35px", background: "rgb(239, 239, 239)" },
  buttonClass: "",
  textStyle: undefined,
  textClass: "",
  containerStyle: undefined,
  containerClass: "",
  onMinBound: () => { },
  onMaxBound: () => { }
};

export default RangeSelector;
